module.exports = __webpack_public_path__ + "img/warbenmini.4cbb6289.svg";